import axios from 'axios';
import actions from '../actions/eventRegistration';

export default {
	namespaced: true,
	state: {
		competitionList: [],
		links: [],
		selectedEvent: null,
	},
	mutations: {
		[actions.SET_EVENT_COMPETITION]: (state, data) => {
			state.competitionList = data;
		},
		[actions.SET_LINK]: (state, data) => {
			state.links = data.links;
		},
		[actions.SET_SELECTED_EVENT]: (state, event) => {
			state.selectedEvent = event;
		},
		[actions.CLEAR]: (state) => {
			state.competitionList = [];
			state.links = [];
			state.selectedEvent = null;
		},
	},
	actions: {
		[actions.GET_EVENT_REG_LINKS]: async ({ commit, rootState }) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'eventreg_links');

				const response = await axios.get(link.href);

				const { data } = response;

				commit(actions.SET_LINK, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_EVENT_COMPETITIONS]: async ({ commit, state }) => {
			try {
				const link = state.links.find(x => x.rel === 'get_current_events');

				const response = await axios.get(link.href);

				const { data } = response;

				commit(actions.SET_EVENT_COMPETITION, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_USER_DATA]: async ({ state }) => {
			try {
				const link = state.links.find(x => x.rel === 'get_user_data');

				const response = await axios.get(link.href);

				const { data } = response;

				return data;
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_EVENT_REG_BY_ID]: async ({ commit }, href) => {
			try {
				const resp = await axios.get(href);
				const { data } = resp;

				commit(actions.SET_SELECTED_EVENT, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.ADD_ATTENDENCE]: async ({ commit }, { href, data }) => {
			try {
				await axios.post(href, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.CONFIRM_MAIL]: async ({ commit }, href) => {
			try {
				const ret = await axios.get(href);
				const { data } = ret;
				return data;
			} catch (error) {
				throw error;
			}
		},
		[actions.REMOVE_ATTENDENCE]: async ({ commit }, href) => {
			try {
				const ret = await axios.get(href);
				const { data } = ret;
				return data;
			} catch (error) {
				throw error;
			}
		},
		[actions.CLEAR]: async ({ commit }) => {
			commit(actions.CLEAR);
		},
	},
	getters: {
		EventCompetitions: state => state.competitionList,
		SelectedEvent: state => state.selectedEvent,
		Links: state => state.links,
	},
};
